import type { User } from '../../api/types'
import { Avatar } from '../../components/Avatar'

export function MentionMenu({ users, activeIndex, onChoose }: { users: User[]; activeIndex: number; onChoose: (user: User) => void }) {
  return (
    <div className="popover mention-menu" role="listbox" aria-label="Mention someone">
      {users.map((user, index) => (
        <button
          key={user.id}
          type="button"
          role="option"
          aria-selected={index === activeIndex}
          data-active={index === activeIndex}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onChoose(user)}
        >
          <Avatar user={user} />
          <span>{user.displayName}</span>
          <small>@{user.username}</small>
        </button>
      ))}
    </div>
  )
}
